'use client';
import { use, useEffect, useRef, useState } from 'react';
import Chat from "./Chat/Chat" 
import { useUser } from '../context/UserContext';
import { RequestChatBotProject } from '../models/interfaceChatBotProject';
import { searchChatbotProject } from '../services/chatbotprojectsearch';
import { getCookie } from '../helpers/cookies'; 
import LayoutHeader from './LayoutCustom/LayoutHeader'; 

import { AccessType, AlertType, integrationOrder, ModeLayout, PanelLayout, QuotaUserStatus, TypeEnvironment, TypeLayout } from '../constants/enums';
import { iDatacenter, iProComponent, iProDoc, iProjectQa, iProProject, iProProjectMain } from '../models/interfaceProject';
import { Edit2, Eye, PanelLeftOpen, PanelRightOpen, Save, Settings, Unlink, Flag, ChevronDown, ChevronUp, Check } from 'lucide-react';
import { chatbotHealthCheck } from '../services/chatbotHealthCheck';
import Modal from './Elements/Modal';
import LayoutLeft from './LayoutCustom/LayoutLeft';
import LayoutRight from './LayoutCustom/LayoutRight';
import { getDefaultProProjecIntegration, getDefaultProProjectMain} from '../constants/defaultValue';
import { charbotSaveProject } from '../services/charbotSaveProject';
import { mapProProjectToSaveMain, mapProProjectToSavePublish, validateChproIntegrations, validateProject } from '../helpers/projectToSave';
import Loading from './Elements/Loading';
import { useRouter } from "next/navigation";
import LayoutPrincipal from './LayoutCustom/LayoutPrincipal';
import { updatePageInformation } from '../helpers/updatePageInfo';

import { db } from "@/app/helpers/firebase";
import { collection, doc, onSnapshot, query, where} from "firebase/firestore";
import { iQuotaConfig, iQuotaUser } from '../models/interfaceQuotaConfiguration';
import { listConversations } from '../services/conversationService';
import { charbotSaveProjectPublish } from '../services/charbotSaveProjectPublish';
import { useConfig } from '../context/ConfigContext';
import { getcurrentUser } from '../helpers/functions';
import { iResponse } from '../models/interfaceResponse';
import { chatBotProjectQuotaConfig } from '../services/chatBotProjectQuotaConfig';

export default function Layout({ modeViewLayout = ModeLayout.View}: {modeViewLayout?: string;}) { 
  const { queryParams, baseUrl, path, params, segments } = useConfig();

  
  const { typeLayout, setTypeLayout,
      showHeader, setShowHeader,
      user, setUser,
      userLoginInfo, 
      accessType,setAccessType,
      userLoaded, setUserLoaded,
      userProject,setUserProject,
      userProjectLoading, setUserProjectLoading,
      userProjectLoaded, setUserProjectLoaded,
      activePanel, setActivePanel,
      modeLayout, setModeLayout,
      formSchemaJson, setFormSchemaJson,
      myDocs, setMyDocs, 
      listConversation, setListConversation,
      listConversationLoading,setListConversationLoading,
      addAlert,
    } = useUser();
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [isSaveSucces, setIsSaveSucces] = useState(false);
    const [idProjectSaved, setIdProjectSaved] = useState<string>("");
    const [mensajeModal, setMensajeModal] = useState("");
    const [isSmallScreen, setIsSmallScreen] = useState(false);
     
    // setBaseUrl("https://playdev2-inca.web.app"); // Ubicar en  ConfigContext.tsx
    
    
    // PROYECTI
    // Project Document
    const fetchDataProject = async () => { 
      setUserProjectLoading(true);
      if (userLoaded) {
        const aliasParam = params.p0!=ModeLayout.Edit?params.p0:"";
        setModeLayout(modeViewLayout??modeLayout);// edit o view
        setTypeLayout(queryParams.type);// conversation, advisor, personal
        if( modeViewLayout==ModeLayout.Edit){
          if(!queryParams.key_p && !user.isAnonymous){ 
            setUserProject(getDefaultProProjectMain(queryParams.type,TypeEnvironment.Dev)); 
            setUserProjectLoading(false);
            setUserProjectLoaded(true);
            closeModal();
            return;
          }else if(queryParams.key_p && user.isAnonymous){ 
            updateQuery(ModeLayout.View, queryParams?.key_p??"")
            return;
          }
        } 
        
        const paramsProject: RequestChatBotProject = {
          key_p:queryParams.key_p,//""
          key_u: queryParams.key_u,//
          user_id: getcurrentUser(accessType, userProject, user), 
          base_url: baseUrl,//
          type:"PLAYGROUND",//
          alias:aliasParam
        }; 
        
        try {
          //openModal();  
          const response = await searchChatbotProject(paramsProject); 
          if (response.code == 400){
              openModal();
              setMensajeModal(response.message + ' o Ud. no tiene acceso al proyecto');
              setUserProject(null);
              setUserProjectLoaded(false);
          } else if(response.success && response.code == 200){
            const project = response.data as iProProjectMain;
            //project.project.env = project.project.env??TypeEnvironment.Dev;
            

            // Inicializacion con proyectos
            setTypeLayout(project.project.chatbot_type);
            // redirecion si es editor y no sea el mismo logeado          
            //if(project?.project?.created_user !== user.email && mode==ModeLayout.Edit){
            //  updateQuery(ModeLayout.View, key_p??"") 
            //}
          
            
            if (!project.project?.loggin_disabled && user.isAnonymous){
              openModal();
              setUserProject(null);
              setMensajeModal('Acceso restringido: debes iniciar sesión con una cuenta registrada para continuar.'); 
              return;
            }else{
              closeModal();
            }
            
            if( modeViewLayout !== ModeLayout.View && project?.project?.created_user !== user.email &&
              project?.project?.private_access && 
              project?.project?.permissions.filter(O=>O.email === user.email&&O.administrator).length == 0
            ){ 
              updateQuery(ModeLayout.View, queryParams.key_p) 
            } 
          
            // asignacion de documentos en true          
            const schemaComponents = project.project.components?.filter(O=>!O.deleted).map(schema => ({ ...schema, view_edit: true })); 
            console.log("schemaComponents",schemaComponents)
            setFormSchemaJson(schemaComponents);
            // actulizacion de documentos
            //const updatedDocs = project.docs.map(doc => ({
            //  ...doc,
            //  seleccionado: true,
            //  file_id_local:crypto.randomUUID(),
            //  status:doc.status??""
            //})); 
            const updatedDocs = [
                                ...(project.docs || []),
                                ...(project.datacenter?.drive_files || [])
                              ].map(doc => ({
                                ...doc,
                                seleccionado: true,
                                file_id_local: crypto.randomUUID(),
                                status: doc.status ?? ""
                              }));

            const ds = project?.config?.datastores?.[0] ?? {};
            const datacenter = { 
                  documents_file_flag: false,
                  name: project.config.prompt_params.assistant_name,
                  datacenter_id: ds.datacenter_id ?? null,
                  database_service_id: ds.database_service_id ?? null,
                  description: project.project.description,
                  deleted_qa:false,
                  files: updatedDocs.map(doc => ({
                      file_id:doc.file_id,
                      chunk_overlap: doc.chunk_overlap, //
                      chunk_size: doc.chunk_size, // 
                      file_type: doc.file_type,//
                      file_size: doc.file_size,//
                      file_url: doc.file_url,//
                      type: doc.type,//
                      name: doc.name,//
                      columns: doc.columns, //XLS
                      embedded_column: doc.embedded_column,//XLS 
                      deleted: doc.deleted,
                      file_id_local:doc.file_id_local,
                      status:doc.status,
                      created_date: doc.created_date,
                      file_origin:doc.file_origin,
                      drive_id:doc.drive_id,
                      drive_mime_type:doc.drive_mime_type,
                      drive_version: doc.drive_version,
                      drive_modified_time: doc.drive_modified_time,
                      drive_url: doc.drive_url,
                    })) ?? [], 
            } as iDatacenter;
            const qa = project?.qa.map(q => ({
              qa_id:q.qa_id,
              chunk_overlap:q.chunk_overlap,
              chunk_size: q.chunk_size,
              question: q.question,
              answer: q.answer,
              deleted: q.deleted,
              edit: false,
              qa_id_local:crypto.randomUUID() 
            })) ?? [] as iProjectQa[]; 
            // integraciones 
            const existingIntegrations = project.project.chpro_integrations ?? [];
            const existingTypes = new Set(existingIntegrations.map(integration => integration.type));           
            const defaultIntegrations = getDefaultProProjecIntegration().filter(integration => !existingTypes.has(integration.type));
            const updatedChproIntegration = [...existingIntegrations, ...defaultIntegrations];
            updatedChproIntegration.sort((a, b) => (integrationOrder[a.type] ?? 99) - (integrationOrder[b.type] ?? 99));

            const users: iQuotaUser[] = (project.project.users ?? []).map(
                (u) => ({ ...u, status: QuotaUserStatus.Existing })
              );
            const groups = project.project.groups??[];
            
            //const updatedProject = {
            //  ...project,
            //  docs: updatedDocs,
            //  datacenter:datacenter,
            //  qa:qa,
            //  useDocs:true
            //} as iProProjectMain; 

            // CONSULTA QUOTAS
            let quotaData: iQuotaConfig = { domain_quota: 0, total_quota_project_domain:0, group_user_quota: null, project_group_user_quota: null, project_quota: 0, project_user_quota: 0, user_quota: 0,};
            if(modeViewLayout==ModeLayout.Edit){
               try {
                    const request = {
                        domain: project?.project?.domain,//||userLoginInfo.domain, //--"intercorp.com.pe",//user.email.split("@")[1] || "",
                        project_id: project?.project.id ?? "",
                        user: user.email,
                    };  
                    const responseQuota: iResponse = await chatBotProjectQuotaConfig(request);
                    if (responseQuota.success && responseQuota.data) {
                        quotaData = responseQuota.data as iQuotaConfig; 
                    }else{ 
                      addAlert("No se encontraron datos de cuotas, se aplicaron valores por defecto.", AlertType.Warning);
                    } 
                } catch (error) { 
                    addAlert("Error al consultar cuotas, usando valores por defecto.", AlertType.Error);
                }
            } 

            const updatedProject = {
              ...project,
              project: {
                ...project.project,
                chpro_integrations: updatedChproIntegration,
                users:users,
                groups:groups,
                quota_config:quotaData,
                quota_project_domain:quotaData?.total_quota_project_domain??0,
                quota:quotaData?.project_quota ?? 0, 
              },
              docs: updatedDocs,
              datacenter: datacenter,
              qa: qa,
              useDocs: true
            } as iProProjectMain;

            setUserProject(updatedProject);  
          }else {
            setUserProject(null); 
          } 
        } catch (error:any) {
          setUserProject(null);
        } finally { 
          setUserProjectLoading(false);
          setUserProjectLoaded(true);
          
        } 
        const responseHealthCheck = await chatbotHealthCheck(paramsProject);   
      }  
    }

  // CONVERSACION 
  
  const fetchConversations = async () => {
    setListConversationLoading(true);
    try {
      const res = await listConversations({
        user_id: getcurrentUser(accessType, userProject, user),
        project_id: userProject?.project?.id ?? "",
        company_code: userProject?.project?.company_code ?? "",
      }, user, setUser);
      setListConversation(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      console.error(e);
    } finally {
      setListConversationLoading(false);
    }
  };


  useEffect(() => {   
    //if(user?.email && accessType==AccessType.LogIn && userProject?.project?.id && modeViewLayout==ModeLayout.View){
    //  fetchConversations()
    //}

    
    if(user?.email&& user?.email!="") { 
      fetchDataProject();
    }else{
      if (myDocs) {
        const updatedDocs = myDocs.map(doc => ({ ...doc, seleccionado: false }));
        setMyDocs(updatedDocs);
      }
    }
  }, [user?.email]);

  useEffect(() => {  
    if(userProject){
      updatePageInformation(userProject);
    }    
  }, [userProject?.project?.icono,userProject?.project?.project_name,userProject?.project?.description]);

  
  useEffect(() => {  
    if(user?.email && accessType==AccessType.LogIn && userProject?.project?.id && modeViewLayout==ModeLayout.View){
      fetchConversations()
    }
  }, [user?.email, accessType, userProject?.project?.id, modeViewLayout]);

 
  //useEffect(() => {  
  //  if(userProject){
  //    updatePageInformation(userProject);
  //  }    
  //}, [userProject?.project?.icono,userProject?.project?.project_name,userProject?.project?.description]);

  const ajustarAltura = (id:string,h = 85,h_min = 300) => { 
      const elemento = document.getElementById(id);
        if (elemento) { 
          if((window.innerHeight-h) < (h+h_min)){
            elemento.style.height = `${h_min+h}px`;
            
          }else{
            elemento.style.height = `${window.innerHeight-h}px`;
          }
        } 
    };
    
  useEffect(() => { 
    const ajustarAlturaBody = () => { 
      if (typeof window !== "undefined") {
        if(window.innerHeight<=700){
          setIsSmallScreen(true);
          ajustarAltura('n-cnt-content',0,0); 
          setShowHeader(false); 
        }else{
          ajustarAltura('n-cnt-content'); 
          setShowHeader(true);
          setIsSmallScreen(false);
        }

        if(typeLayout == TypeLayout.Advisor){
          ajustarAltura('n-cnt-left');
          ajustarAltura('n-cnt-right');
        }else if(typeLayout == TypeLayout.Personal ){
          ajustarAltura('n-cnt-left');
        }
      }
    }; 
    ajustarAlturaBody();  // Establece la altura inicial
    window.addEventListener('resize', ajustarAlturaBody); 
    return () => window.removeEventListener('resize', ajustarAlturaBody);
  }, [userProjectLoading]);

  // ------------------- MODAL -----------------
  const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

  //------------------- SAVE -------------------
  const handleSaveProject = async (e: React.FormEvent) => {
      e.preventDefault();
      // validaciones 
      if (!validateProject(userProject, userLoginInfo, addAlert)) {
        return ;
      } 

      if (typeLayout===TypeLayout.Conversation &&!validateChproIntegrations(userProject?.project?.chpro_integrations, addAlert)) {
        return ;
      } 
      setIsLoadingSave(true); 
      try { 
        const response = await charbotSaveProject(mapProProjectToSaveMain(userProject,formSchemaJson as iProComponent[],user),user,setUser); 
        if(response.success && response.code == 200){ 
            setIsSaveSucces(true);
            setIdProjectSaved(String(response.data));
            updateQuery(ModeLayout.View, String(response.data));
        }else if(response.code == 403){
          setIsSaveSucces(false);          
          addAlert(response.message, AlertType.Error);
        } else{
          setIsLoadingSave(false);
          setIsSaveSucces(false);
          addAlert(response.message, AlertType.Error);
        } 
      } catch (error) { 
        setIsSaveSucces(false);
        setIsLoadingSave(false);
        console.error("Error guardar",error) 
        //addAlert(error, AlertType.Error);
      } finally { 
        //setIsLoadingSave(false); 
        
      }
  }
  
  const handleSavePublish = async (e: React.FormEvent) => {
      e.preventDefault();

      // validaciones 
      //if (!validateProject(userProject, userLoginInfo, addAlert)) {
      //  return ;
      //} 

      //if (typeLayout===TypeLayout.Conversation &&!validateChproIntegrations(userProject?.project?.chpro_integrations, addAlert)) {
      //  return ;
      //} 
      setIsLoadingSave(true); 
      try {   

        const response = await charbotSaveProjectPublish(mapProProjectToSavePublish(userProject,user), user,setUser)   
        if(response.success && response.code == 200){ 
            setIsSaveSucces(true); 
            const prodProject = response.data as iProProject;
            updateQuery(ModeLayout.View, prodProject.id??"");
        } else{
          setIsSaveSucces(false);
          addAlert(response.message, AlertType.Error);
        } 
      } catch (error) { 
        setIsSaveSucces(false);
        console.error("Error guardar",error) 
      } finally { 
        //setIsLoadingSave(false); 
      }
  }


  const prevDocsRef = useRef<iProDoc[]>([]); 
  
  const handleReportIncident = () => {
    const baseUrl = 'https://forms.monday.com/forms/embed/5ca7ed444db01376168595c49379d596?r=use1';
    const url = new URL(baseUrl);
    if (user?.email) {
      url.searchParams.append('usuario_solicitante', user.email);
    }

    const layout = typeLayout;
    const layoutParam: Record<TypeLayout, string> = {
      [TypeLayout.Advisor]: '4',
      [TypeLayout.Conversation]: '2',
      [TypeLayout.Personal]: '3',
      [TypeLayout.Default]: '',
      [TypeLayout.Channel]: '',
    };

    const paramToForm = layoutParam[layout];
    if (paramToForm) {
      url.searchParams.append('color_mkprdqs0', paramToForm);
    }
    window.open(url.toString(), '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    if(accessType==AccessType.Incognito){
      return 
    }

      if (userProject?.datacenter) {
        const datacenterId = userProject?.datacenter?.datacenter_id;
        const projectId = userProject?.project?.id;
        const domain = userProject?.project?.domain
        if (!datacenterId || !projectId) { 
      return;
    }
        const collectionRef = collection(db, domain, "chatbots", "chatbot_datacenter", datacenterId, "chatbot_files");
        const q = query(collectionRef, where("deleted", "==", false)); 
        const unsubscribe = onSnapshot(q, (snapshot) => {
          // const filesArray = snapshot.docs.map((doc) => doc.data());
          const filesArray: iProDoc[] = snapshot.docs.map((doc) => ({
            ...(doc.data() as iProDoc),
            //seleccionado: false,
            //status: "pending",
          }));
 
          if (JSON.stringify(prevDocsRef.current) === JSON.stringify(filesArray)) {
            return;
          }

          prevDocsRef.current = filesArray;
          const datacenterFiles = userProject?.datacenter?.files.map((file) => { 
            const matchingFile = filesArray.find((f) => f.file_id === file.file_id); 
            if (matchingFile) { return { ...file, status: matchingFile.status, }; }          
            return file;
          }); 

          const newUserProject = {
            ...userProject,
            docs: filesArray,
            datacenter: {
              ...userProject.datacenter,
              files: datacenterFiles,
            },
          } as iProProjectMain;

          setUserProject(newUserProject);
          
        });
        const docRefProject = doc(
          db,
          domain,
          "chatbots",
          "chatbot_projects",
          projectId
        );
        const unsubscribeNotifications = onSnapshot(docRefProject, (docSnap:any) => {
          if (docSnap.exists()) {
            const projectData = docSnap.data();
            setUserProject((prev: iProProjectMain | null)  => ({
              ...prev!,
              project: {
                ...prev!.project,
                notifications: projectData.notifications ?? [],
              },
            }));
          }
        });
        return () => {
          unsubscribe();
          unsubscribeNotifications();
        };
      }
    }, [
  userProject?.datacenter?.datacenter_id,
  userProject?.project?.id,
  userProject?.project?.domain,
  ]);

    


 

// REDIRECION
  const router = useRouter();
  const updateQuery = (modo_view:string, vIdPrject:string="") => {
    const params = new URLSearchParams(window.location.search); 
    const newKeyPValue = vIdPrject==""?userProject.project.id:vIdPrject; 
    //params.set("key_p", newKeyPValue); 
    if (params.has("key_p")) {
      params.set("key_p", newKeyPValue??"");
    } else {
      params.append("key_p", newKeyPValue??"");
    } 



    //if(modo_view == ModeLayout.Edit){
    //  router.push(`/${modo_view}/?${params.toString()}`); 
    //}else{
    //  router.push(`/?${params.toString()}`); 
    //} 
    //setModeLayout(modo);

    const url =
      modo_view === ModeLayout.Edit
        ? `/${modo_view}/?${params.toString()}`
        : `/?${params.toString()}`; 
    window.location.href = url;

  };

//accessType==AccessType.LogIn
  // quotas
  const fetchQuotaConfig = async () => {
      if(modeViewLayout==ModeLayout.View) return;

      const defaultQuotaConfig: iQuotaConfig = {
          domain_quota: 0,
          total_quota_project_domain:0,
          group_user_quota: null,
          project_group_user_quota: null,
          project_quota: 0,
          project_user_quota: 0,
          user_quota: 0,
      };
        try {
            const request = {
                domain: userProject?.project?.domain,//||userLoginInfo.domain, //--"intercorp.com.pe",//user.email.split("@")[1] || "",
                project_id: userProject?.project.id ?? "",
                user: user.email,
            };  
            const response: iResponse = await chatBotProjectQuotaConfig(request);
            //console.log("response",response)
            if (response.success && response.data) {
                const quotaData = response.data as iQuotaConfig; 
                setUserProject((prev: any) => ({
                        ...prev,
                        project: {
                        ...prev.project,
                        quota_project_domain: quotaData.total_quota_project_domain??0,
                        quota_config: quotaData ?? defaultQuotaConfig,
                        quota: quotaData?.project_quota ?? 0,
                    },
                }));
            } else { 
                setUserProject((prev: any) => ({
                    ...prev,
                    project: {
                    ...prev.project,
                    quota_project_domain: 0,  
                    quota_config: defaultQuotaConfig
                    },
            }));
                addAlert("No se encontraron datos de cuotas, se aplicaron valores por defecto.", AlertType.Warning);
            }
        } catch (error) { 
            setUserProject((prev: any) => ({
                ...prev,
                project: {
                    ...prev.project,
                    quota_project_domain: 0,  
                    quota_config: defaultQuotaConfig,
                },
            }));
            addAlert("Error al consultar cuotas, usando valores por defecto.", AlertType.Error);
            }
    };


  if (!userProjectLoaded) {
    return (
       <div className="min-h-screen flex flex-col text-gray-700"> 
        {/* Header */}
        <button
          onClick={() => {
            let h = 0;
            let min_h=0;
            if(showHeader){
              h = 0; min_h=0;
              setShowHeader(false);
            }else{
              h = 80; min_h=300;
              setShowHeader(true);
            }

            ajustarAltura('n-cnt-content',h,min_h);
            if(typeLayout == TypeLayout.Advisor){
              ajustarAltura('n-cnt-left',h,min_h);
              ajustarAltura('n-cnt-right',h,min_h);
            }else if(typeLayout == TypeLayout.Personal ){
              ajustarAltura('n-cnt-left',h,min_h);
            } 
          }}
          className={`fixed -top-3 right-[100px] 
            z-50 px-3 pt-2 btn-inca-secondary 
            border btn-inca-secondary rounded-full shadow-md hover:bg-blue-700 transition 
            ${isSmallScreen ? "block" : "hidden"} `}
        >
          {showHeader ? <ChevronUp /> : <ChevronDown />}
        </button>  
        <LayoutHeader show={showHeader} /> 
          <div className="flex flex-1 flex-col items-center justify-center n-bg-global-main">
            <Loading w="w-3" h="h-3" className="mb-2" /> 
          </div>
      </div>
 
    );
  }
  
  return (
    <div className="min-h-screen flex flex-col text-gray-700"> 
    
        {/* Header */}
        <button
          onClick={() => {
            let h = 0;
            let min_h=0;
            if(showHeader){
              h = 0; min_h=0;
              setShowHeader(false);
            }else{
              h = 80; min_h=300;
              setShowHeader(true);
            }

            ajustarAltura('n-cnt-content',h,min_h);
            if(typeLayout == TypeLayout.Advisor){
              ajustarAltura('n-cnt-left',h,min_h);
              ajustarAltura('n-cnt-right',h,min_h);
            }else if(typeLayout == TypeLayout.Personal ){
              ajustarAltura('n-cnt-left',h,min_h);
            } 
          }}
          className={`fixed -top-3 right-[100px] 
            z-50 px-3 pt-2 btn-inca-secondary 
            border btn-inca-secondary rounded-full shadow-md hover:bg-blue-700 transition 
            ${isSmallScreen ? "block" : "hidden"} `}
        >
          {showHeader ? <ChevronUp /> : <ChevronDown />}
        </button>  
        <LayoutHeader show={showHeader} /> 
              

        {/*
        <button
          onClick={() => setShowHeader((prev) => !prev)}
          className="fixed -top-2 left-10 z-50 px-3 pt-2 rounded-lg shadow-md hover:bg-slate-500 hover:text-white transition bg-slate-200 "
        >
          {showHeader ? <ChevronUp /> : <ChevronDown />} 
        </button>
        {showHeader && <LayoutHeader />}
        */} 
        {userProjectLoading ? (
          <div className="flex flex-1 flex-col items-center justify-center n-bg-global-main">
            <Loading w="w-3" h="h-3" className="mb-2" /> 
            {/*<span className="text-gray-500">Cargando</span>*/}
        </div>
        ) : ( userProject==null?'':
          <div className="flex-1 lg:flex"> 
              {/* Botones para abrir paneles en pantallas pequeñas */} 
              <div className="lg:hidden relative"> 
                { accessType==AccessType.LogIn && (typeLayout === TypeLayout.Advisor || typeLayout === TypeLayout.Personal) && (activePanel === PanelLayout.Left?
                  <button
                    onClick={() => setActivePanel(null)}
                    className="fixed top-24 z-20 left-1 p-2 border btn-inca-secondary rounded-full shadow-md hover:bg-blue-700 transition"
                  >
                    <PanelRightOpen strokeWidth={0.8} className={`w-6 h-6 block `}/>
                  </button>
                :
                  <button
                    onClick={() => setActivePanel(PanelLayout.Left)}
                    className="fixed top-24 z-20 left-1 p-2 border btn-inca-secondary rounded-full shadow-md hover:bg-blue-700 transition"
                  >
                    <PanelLeftOpen strokeWidth={0.8} className={`w-6 h-6 block `}/>
                  </button> 
              )}

                
                {accessType==AccessType.LogIn &&(typeLayout == TypeLayout.Advisor)&&(activePanel === PanelLayout.Right?
                  <button
                    onClick={() => setActivePanel(null)}
                    className="fixed top-24 right-1 z-20 p-2  border btn-inca-secondary rounded-full shadow-md hover:bg-blue-700 transition"
                  >
                    <PanelRightOpen strokeWidth={0.8} className={`w-6 h-6 block `}/>
                  </button>
                :
                  <button
                    onClick={() => setActivePanel(PanelLayout.Right)}
                    className="fixed top-24 right-1 z-20 p-2 border btn-inca-secondary rounded-full shadow-md hover:bg-blue-700 transition"
                  >
                    <PanelLeftOpen strokeWidth={0.8} className={`w-6 h-6 block `}/>
                  </button>
                ) }
                
              </div> 

              
              {/* Panel Izquierdo */}
              {accessType==AccessType.LogIn &&userProject&&((typeLayout == TypeLayout.Personal && modeLayout==ModeLayout.View) || (typeLayout == TypeLayout.Advisor)  )&&
                  <div
                    id="n-cnt-left"
                    className={`fixed inset-x-0 bg-gray-50 lg:static lg:w-1/5 lg:bg-gray-50 p-4 transition-transform overflow-x-hidden scroll-custom 
                      ${ activePanel === PanelLayout.Left ? "translate-x-0" : "-translate-x-full" }
                      ${ modeLayout === ModeLayout.Edit ? " rounded-lg border-dashed border border-blue-800 " : "lg:border-r" }
                      
                      lg:translate-x-0
                      z-10`} 
                  > 
                    <LayoutLeft/>
                  </div> 
              } 

              {/* Contenido Principal */}
              <div 
                id="n-cnt-content"
                className={`flex-1 flex flex-col justify-between overflow-x-hidden scroll-custom-content bg-gray-100
                  ${ modeLayout === ModeLayout.Edit ? " rounded-lg border-dashed border border-blue-800  mx-4 items-center justify-center " : "" }
                  `} 
              >
                {userProject&&(modeLayout === ModeLayout.Edit ?<LayoutPrincipal />:<Chat />)}
                
              </div>

              {/* Panel Derecho */}
              {accessType==AccessType.LogIn &&(userProject&&(typeLayout == TypeLayout.Advisor))&&(
                <div
                  id="n-cnt-right"
                  className={`fixed inset-x-0 top-16 bg-gray-50 lg:static lg:w-1/5 lg:bg-gray-50 lg:border-l p-4 transition-transform overflow-x-hidden scroll-custom 
                  
                    ${ activePanel === PanelLayout.Right ? "translate-x-0" : "translate-x-full" } 
                    ${ modeLayout === ModeLayout.Edit ? " rounded-lg border-dashed border border-blue-800 " : "lg:border-l" }
                    lg:translate-x-0
                    z-10`}
                >
 
                  <LayoutRight/>
                </div> 
              )}




              {user&&!user?.isAnonymous&&(
                <button
                  type="button"
                  onClick={handleReportIncident} 
                  title="Reportar incidente"
                  className={`absolute lg:mb-0 sm:left-4 left-3 sm:mb-3 sm:bottom-28 bottom-32 lg:bottom-2
                    flex items-center justify-center gap-2 md:gap-1 lg:gap-2
                    sm:px-6 px-2.5 py-2.5 rounded-full font-medium text-sm tracking-wide
                    transition-all duration-300 ease-in-out shadow-sm border z-50
                    focus:outline-none focus:ring-2 focus:ring-rose-200 focus:ring-offset-1                    
                    bg-red-400 hover:bg-red-500 active:bg-red-800  border-transparent
                    text-white`}
                >
                  <Flag
                    className={`w-5 h-5 transition-transform duration-200 group-hover:scale-105 group-active:scale-95 `}
                    strokeWidth={1.6}
                  />
                  <span className="hidden sm:inline">Reportar</span>
                </button> 

              )}

              {(modeLayout==ModeLayout.Edit)?
                (userProject&&
                  (
                    (user&&userProject?.project?.created_user === user.email||
                     user&&userProject?.project?.permissions.filter(O=>O.email === user.email&&O.administrator).length >= 1 || 
                     !userProject?.project?.id) &&
                  user&&!user?.isAnonymous
                  )?
                  <div className="fixed lg:mb-0 sm:mb-3 transition-all duration-300 ease-in-out sm:bottom-28 bottom-32 lg:bottom-2 sm:right-4 flex sm:flex-row flex-col flex-wrap justify-end items-center sm:gap-3 z-50 gap-1 right-4">
                    {isLoadingSave ? (
                        <Loading w="w-3" h="h-3"  />
                      ) : (
                        <>
                          {
                          userProject.project.env === TypeEnvironment.Prod
                            ? <>
                            <button
                                type="button"
                                className={`bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white border border-emerald-600 hover:border-emerald-700
                                    group flex items-center gap-2 sm:px-6 px-2.5 py-2.5 rounded-full justify-center
                                    font-semibold text-sm tracking-wide shadow-sm transition-all duration-200
                                    focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-1`}
                                onClick={()=>{updateQuery(ModeLayout.Edit,userProject.project.dev_project_id??"")}} 
                                title='Ir Sandbox'
                              >
                                <Edit2
                                  className="w-5 h-5 transition-transform duration-200 group-hover:scale-110 group-active:scale-95"                                   
                                  strokeWidth={1.5}/>
                                <span className='hidden sm:inline'>Ir Sandbox</span>
                              </button> 
                              <button
                                type="button"
                                className={`bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white border border-emerald-600 hover:border-emerald-700
                                    group flex items-center gap-2 sm:px-6 px-2.5 py-2.5 rounded-full justify-center
                                    font-semibold text-sm tracking-wide shadow-sm transition-all duration-200
                                    focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-1`}
                                onClick={handleSaveProject}
                                disabled={isLoadingSave}
                                title="Guardar"
                              >
                                <Save
                                    className="w-5 h-5 transition-transform duration-200 group-hover:scale-110 group-active:scale-95"                                   
                                    strokeWidth={1.5} />
                                <span className="hidden sm:inline">Guardar</span>
                              </button>
                            </>
                            : userProject.project.env === TypeEnvironment.Dev
                              ? <>
                                <button
                                  type="button"
                                  className={`bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white border border-emerald-600 hover:border-emerald-700
                                    group flex items-center gap-2 sm:px-6 px-2.5 py-2.5 rounded-full justify-center
                                    font-semibold text-sm tracking-wide shadow-sm transition-all duration-200
                                    focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-1`}
                                  onClick={handleSaveProject}
                                  disabled={isLoadingSave}
                                  title="Probar"
                                > 
                                  <Eye
                                    className="w-5 h-5 transition-transform duration-200 group-hover:scale-110 group-active:scale-95"                                   
                                    strokeWidth={1.5} />
                                  <span className="hidden sm:inline">Probar</span> 
                                </button> 

                              </>
                              : ""
                          } 
                        </>
                      )}

                  </div> 
                  :""
                ) 
                : 
                ( 
                  (user && userProject?.project?.created_user === user.email ||
                    user&&userProject?.project?.permissions.filter(O=>O.email === user.email && O.administrator ).length >= 1) ? 
                  <div className="fixed lg:mb-0 sm:mb-3  transition-all duration-300 ease-in-out sm:bottom-28 bottom-32 lg:bottom-2 sm:right-4 flex sm:flex-row flex-col flex-wrap justify-end items-center sm:gap-3 z-50 gap-1 right-4">
                    {isLoadingSave ? (
                        <Loading w="w-3" h="h-3"  />
                      ) : (
                      <>
                          {
                          userProject.project.env === TypeEnvironment.Prod
                            ? <>
                              <button
                                type="button"
                                className={`bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white border border-emerald-600 hover:border-emerald-700
                                    group flex items-center gap-2 sm:px-6 px-2.5 py-2.5 rounded-full justify-center
                                    font-semibold text-sm tracking-wide shadow-sm transition-all duration-200
                                    focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-1`}
                                onClick={()=>{updateQuery(ModeLayout.Edit,userProject.project.dev_project_id??"")}} 
                                title='Ir Sandbox'
                              >
                                <Edit2
                                  className="w-5 h-5 transition-transform duration-200 group-hover:scale-110 group-active:scale-95"                                   
                                  strokeWidth={1.5}/>
                                <span className='hidden sm:inline'>Ir Sandbox</span>
                              </button>
                              <button
                                  type="button"
                                  className={`bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white border border-emerald-600 hover:border-emerald-700
                                    group flex items-center gap-2 sm:px-6 px-2.5 py-2.5 rounded-full justify-center
                                    font-semibold text-sm tracking-wide shadow-sm transition-all duration-200
                                    focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-1`}
                                  onClick={()=>{updateQuery(ModeLayout.Edit,userProject.project.id??"")}} 
                                  title='Modificar'
                                >
                                  <Edit2 
                                    className="w-5 h-5 transition-transform duration-200 group-hover:scale-110 group-active:scale-95"                                   
                                    strokeWidth={1.5}/>
                                  <span className='hidden sm:inline'>Modificar</span>
                                </button>

                            </>
                            : userProject.project.env === TypeEnvironment.Dev
                              ? 
                              <>
                                <button
                                  type="button"
                                  className={`bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white border border-emerald-600 hover:border-emerald-700
                                    group flex items-center gap-2 sm:px-6 px-2.5 py-2.5 rounded-full justify-center
                                    font-semibold text-sm tracking-wide shadow-sm transition-all duration-200
                                    focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-1`}
                                  onClick={() => { updateQuery(ModeLayout.Edit, userProject.project.id ?? "") }}
                                  title="Modificar"
                                  disabled={isLoadingSave}
                                >
                                  <Edit2 
                                    className="w-5 h-5 transition-transform duration-200 group-hover:scale-110 group-active:scale-95" 
                                    strokeWidth={1.75}
                                  />
                                  <span className="hidden sm:inline">Modificar</span>
                                </button>

                                <button
                                  type="button"
                                  className={`bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white border border-emerald-600 hover:border-emerald-700
                                    group flex items-center gap-2 sm:px-6 px-2.5 py-2.5 rounded-full justify-center
                                    font-semibold text-sm tracking-wide shadow-sm transition-all duration-200
                                    focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-1`}
                                  onClick={handleSavePublish}
                                  title="Publicar"
                                >
                                  <Check 
                                    className="w-5 h-5 transition-transform duration-200 group-hover:scale-110 group-active:scale-95" 
                                    strokeWidth={1.5} />
                                  <span className="hidden sm:inline">Publicar</span>
                                </button>
                                
                              </>
                              : ""
                          } 
                      
                      </> 
                    )}
                  </div>
                :""
                ) 
              } 

              
            </div>
            
        )}
     
     {/*
     

     */}
       

      <Modal isOpen={isModalOpen} onClose={closeModal}>
      <div className="flex flex-col items-center justify-center mb-4 px-4 py-3">
          <div className="mb-4 flex items-center justify-center">
              <Unlink />
          </div>
          <p className="text-sm text-gray-600 mb-4 text-center">
              {mensajeModal}
          </p>
      </div>

        {/*<button
          onClick={closeModal}
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          Cerrar Modal
        </button>*/}
      </Modal>

      
 
    </div> 
  );
}